import React, { ReactNode } from 'react';
import noDataPic from '../Assets/NoData.svg';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import { RowWidths } from '@amzn/meridian/row/row';
import Text from '@amzn/meridian/text';
import { css } from '@emotion/css';

export const noDataImage = css({ maxWidth: '120px', maxHeight: '86px' });

interface EmptyStateProps {
  children?: React.ReactNode;
  rowWidths?: RowWidths;
  'data-testid'?: string;
  innerColumnSpacing?: string;
}

const EmptyState = ({
  children,
  rowWidths,
  'data-testid': dataTestId,
  innerColumnSpacing,
}: EmptyStateProps) => {
  return (
    <Column
      spacing='300'
      alignmentVertical='center'
      data-testid={dataTestId ?? 'empty-state'}
    >
      <Column
        alignmentHorizontal='center'
        spacingInset={innerColumnSpacing ?? 'none'}
      >
        <img src={noDataPic} alt='No data' className={noDataImage} />
        <Row
          alignmentHorizontal='center'
          alignmentVertical='center'
          widths={rowWidths ?? ['grid-8']}
        >
          <Text alignment='center' type='b100'>
            {children}
          </Text>
        </Row>
      </Column>
    </Column>
  );
};

export default EmptyState;
